import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

/**
 * The small accent-coloured label above a page or section heading — a route
 * (`/services`), or a short kicker phrase on the home hero. Metadata about
 * where you are, not content, which is why it rides on `.hs-meta` (mono,
 * tracked, uppercase in Latin) rather than the body type scale.
 */
export function Eyebrow({ children, className }: EyebrowProps) {
  return (
    <p className={cn('hs-meta flex items-center gap-2 text-accent', className)}>
      <span className="size-1.5 shrink-0 rounded-full bg-accent" aria-hidden="true" />
      {children}
    </p>
  );
}
